module.exports = __webpack_public_path__ + "img/product_28.817d5bc.jpg";